<template>
    <sa-page-layout :btnNewVisible="true" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource"
        :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading">
        <template #table-filter>
            <div class="sa-list-component-header" style="padding-top: 5px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">
                        <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                                    <label class="sa-label-data">Codice Soggetto</label>

                                    <select class="sa-prescrizione-input sa-select-flex"
                                        v-model="filtroContabilitaSoggetto.codiceTipoSoggetto">
                                        <option :value="null">Tutti</option>
                                        <option v-for="item in codiceSoggettoOptions" :key="item.id"
                                            :value="item.codiceTipoSoggetto">
                                            {{ item.codiceTipoSoggetto }}
                                        </option>
                                    </select>
                                </div>
                                <!--<div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <select class="sa-page-search-component-input" v-model="filtroContabilitaSoggetto.codiceSoggetto"  :options="optionsCodiceSoggetto" />
                                    <button class="sa-page-search-component-btn-search" title="Search">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button class="sa-page-search-component-btn-reset" @click="resetFiltriCodiceSoggetto" type="button"><i class="fas fa-trash"></i></button>
                                </div>-->
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Ragione sociale soggetto</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input"
                                        v-model="filtroContabilitaSoggetto.ragioneSoggetto"
                                        placeholder="Inserisci una ragione.." />
                                    <button class="sa-page-search-component-btn-search" title="Search">
                                        <i class="fas fa-search"></i>
                                    </button>
                                    <button class="sa-page-search-component-btn-reset"
                                        @click="resetFiltriRagioneSoggetto" type="button"><i
                                            class="fas fa-trash"></i></button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
            </div>
        </template>
        <template slot="table-body">
            <contabilita-soggetto-list-component ref="cmpContabilitaSoggettoList" @afterLoadData="afterLoadData"
                @beforeLoadData="beforeLoadData"></contabilita-soggetto-list-component>
        </template>
        <contabilita-soggetto-edit-component ref="cmpContabilitaSoggettoEdit"></contabilita-soggetto-edit-component>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ContabilitaSoggettoEditComponent from "../components/ContabilitaSoggettoEditComponent.vue";
import ContabilitaSoggettoListComponent from "../components/ContabilitaSoggettoListComponent.vue";
import SoggettiMixin from "../mixins/SoggettiMixin";
export default {
    mixins: [SoggettiMixin, UtilityMixin],
    components: { ContabilitaSoggettoListComponent, SaPageLayout, ContabilitaSoggettoEditComponent },
    data() {
        return {
            linkback: "/home",
            linkedit: "/contabilita/soggetto",
            pathResource: "/contabilitasoggetti",
            filtroContabilitaSoggetto: {
                ragioneSoggetto: null,
                codiceTipoSoggetto: null,
            },
            codiceSoggettoOptions: [],
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        me.showModalLoading = true;
        let filtroContabilitaSoggetto = sessionStorage.getItem("filtroContabilitaSoggetto");
        if (!filtroContabilitaSoggetto) {
            me.filtroContabilitaSoggetto = JSON.parse(filtroContabilitaSoggetto);
        }
        me.$refs.cmpContabilitaSoggettoList.loadData(me.filtroContabilitaSoggetto);

        me.loadCodiceSoggettoOptions();
    },
    watch: {
        "filtroContabilitaSoggetto.codiceTipoSoggetto"() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroContabilitaSoggetto", JSON.stringify(me.filtroContabilitaSoggetto));
            this.$refs.cmpContabilitaSoggettoList.loadData(this.filtroContabilitaSoggetto);
        },
    },
    methods: {
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroContabilitaSoggetto", JSON.stringify(me.filtroContabilitaSoggetto));
            me.$refs.cmpContabilitaSoggettoList.loadData(me.filtroContabilitaSoggetto);
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            let filtro = sessionStorage.getItem("filtroContabilitaSoggetto");
            filtro = JSON.parse(filtro);
            me.filtroContabilitaSoggetto = filtro;
            me.showModalLoading = true;
            me.$refs.cmpContabilitaSoggettoList.loadData(me.filtroContabilitaSoggetto);
        },
        resetFiltriRagioneSoggetto() {
            let me = this;
            me.filtroContabilitaSoggetto.codiceTipoSoggetto = null;
            me.filtroContabilitaSoggetto.ragioneSoggetto = null;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroContabilitaSoggetto", JSON.stringify(me.filtroContabilitaSoggetto));
            me.$refs.cmpContabilitaSoggettoList.loadData(me.filtroContabilitaSoggetto);
        },
        loadCodiceSoggettoOptions() {
            let me = this;
            UtilityMixin.methods.loadDataResources("/contabilitasoggettotipi", {}, me.loadCodiceSoggettoSuccess, me.loadCodiceSoggettoError);
        },
        loadCodiceSoggettoSuccess(response) {
            this.codiceSoggettoOptions = response.data.data.list || [];
        },

        loadCodiceSoggettoError(error) {
            console.error("Errore nel caricamento dei codici soggetto", error);
            this.codiceSoggettoOptions = [];
        },
        afterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        beforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
    },
};
</script>

<style lang="scss" scoped></style>
